import { render } from "./TopSellingProduct.vue?vue&type=template&id=c543ca04"
import script from "./TopSellingProduct.vue?vue&type=script&lang=js"
export * from "./TopSellingProduct.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__